import Script from 'next/script'
import { isCookieTypeAccepted } from '@interflora/ui-components/build/utils/common'
/*
 * DO NOT CHANGE THIS CODE WITHOUT GOOD REASON!
 *
 * The functions exported here are responsible for rendering out the
 * The Trade Desk Universal Pixel tracking as defined in the following page:
 * https://partner.thetradedesk.com/v3/portal/data/doc/TrackingTagsUniversalPixel
 *
 * The universal pixel configuration is supplied by environment variables
 * and is specific to each environment.
 *
 * The script only loads when C0004 (Performance/Analytics) cookies are accepted.
 */

export function renderUniversalPixel(siteShorthand: string) {
  const isUK = siteShorthand === 'uk'
  // Check if C0004 cookies (Performance/Analytics cookies) are accepted
  const isC0004Accepted = isCookieTypeAccepted('C0004')
  // Only render if cookies are accepted and configuration is available
  const advertiserId = '50rxkgb'
  const pixelIds = ['2qb8ls6']
  if (!isC0004Accepted) {
    return null
  }
  return isUK ? (
    <>
      <Script id="ttd-universal-pixel-script" src="https://js.adsrvr.org/up_loader.3.0.0.js" async />

      <Script
        id="ttd-universal-pixel-init"
        dangerouslySetInnerHTML={{
          __html: `
            window.ttdConversionEventsLayer = window.ttdConversionEventsLayer || [];
             ttdConversionEvents("init", {
                advertiserId: "${advertiserId}",
                pixelIds: ${JSON.stringify(pixelIds)}
            });
            function ttdConversionEvents() {
                window.ttdConversionEventsLayer.push(arguments);
            }
          `,
        }}
      />
    </>
  ) : null
}

/**
 * Track order conversion event
 * Call this function on order confirmation page to track conversions
 * Only tracks if C0004 cookies are accepted
 */
export function trackOrderConversion(orderId: string, orderValue: number | string) {
  // Check if C0004 cookies are accepted before tracking
  if (typeof globalThis === 'undefined') return
  if (!isCookieTypeAccepted('C0004')) {
    return
  }

  if (globalThis?.ttdConversionEvents) {
    try {
      globalThis.ttdConversionEvents('event', {
        order_id: orderId,
        value: orderValue,
      })
    } catch (error) {
      console.log('Universal Pixel: Error tracking conversion:', error)
    }
  } else {
    console.log('Universal Pixel: ttdConversionEvents not available or C0004 not accepted')
  }
}
